import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "user-info-modal",
  props: ["title", "value", "user"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      groups: [],
      data: {
        old_password: '',
        password: "",
        password2: ""
      },
      rules: {
        old_password: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        },
        password: [{
          type: "string",
          required: true,
          min: 2,
          max: 20
        }, {
          validator: this.passwordConfirmValidator
        }],
        password2: [{
          type: "string",
          required: true,
          min: 2,
          max: 20
        }, {
          validator: this.passwordConfirmValidator
        }]
      },
      loading: false
    };
  },
  methods: {
    onLoad: function onLoad() {},
    handleOk: function handleOk() {
      var _this = this;
      this.loading = true;
      var params = {
        old_password: this.data.old_password,
        new_password: this.data.password2
      };
      return Axios.put('users/current-user/password/', params).then(function (resp) {
        _this.loading = false;
        var _resp$data = resp.data,
          code = _resp$data.code,
          data = _resp$data.data;
        if (code === 0) {
          _this.$Message.success('修改成功！');
          setTimeout(function () {
            _this.$router.push('/login');
          }, 1000);
        }
      }, function (e) {
        _this.loading = false;
        throw e;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.loading = false;
    },
    passwordConfirmValidator: function passwordConfirmValidator(rule, value, callback) {
      var result = true;
      var data = this.data;
      if (data.password2 && data.password) {
        result = data.password === data.password2;
        this._syncPasswordFields(rule.field === "password" ? "password2" : "password", result);
      }
      if (result) {
        callback();
      } else {
        callback([new Error("密码不一致")]);
      }
    },
    _syncPasswordFields: function _syncPasswordFields(field, value) {
      var item = this.$refs[field];
      var SUCCESS = "success";
      var ERROR = "error";
      if (value) {
        if (item.validateState === ERROR) {
          item.validateState = SUCCESS;
        }
      } else {
        if (item.validateState === SUCCESS) {
          item.validateState = ERROR;
        }
      }
    }
  }
};